export default {
      id: "common__more_vertical-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.svg#common__more_vertical",
      toString: function () {
        return this.url;
      }
    }